// 경영지원팀 보드 — 프로젝트별 막대 색 팔레트.
// 여러 프로젝트를 한 달력에 겹쳐 그리면 '어느 프로젝트 막대인가'를 색으로만 구분한다.
// 색은 '화면 목록 순서 index'로 배정한다 — id 해시는 근접 id 끼리 같은 색으로 몰려
// 정작 나란히 보이는 프로젝트가 구분되지 않는다. DB 컬럼은 늘리지 않는다(표시 규칙일 뿐).

export const PROJECT_PALETTE = [
  { bar: '#4F46E5', text: '#ffffff' },
  { bar: '#0891b2', text: '#ffffff' },
  { bar: '#16a34a', text: '#ffffff' },
  { bar: '#d97706', text: '#ffffff' },
  { bar: '#db2777', text: '#ffffff' },
  { bar: '#7c3aed', text: '#ffffff' },
  { bar: '#0284c7', text: '#ffffff' },
  { bar: '#b91c1c', text: '#ffffff' },
];

export function buildProjectColorMap(projects = []) {
  const map = {};
  projects.forEach((project, index) => {
    if (project && project.id !== null && project.id !== undefined) {
      map[project.id] = PROJECT_PALETTE[index % PROJECT_PALETTE.length];
    }
  });
  return map;
}

// 목록에 없는 프로젝트(보관함으로 옮겨간 것 등)도 색 없이 떨어지지 않게 첫 색으로 폴백.
export function projectColorOf(colorMap, projectId) {
  return (colorMap && colorMap[projectId]) || PROJECT_PALETTE[0];
}
